import { classNames } from "@gettactic/helpers/src/css/classNames";
import { InteractiveZonesInfo } from "@gettactic/helpers/src/map/types";
import React from "react";
import { InteractiveActiveSpot } from "./InteractiveActiveSpot";
import { cn } from "@gettactic/helpers";

export interface MapEditSelectedZonesProps {
  selectedZones: string[];
  zonesInfo: InteractiveZonesInfo;
  className?: string;
}
/**
 * Numbers the spots picked while editing a map (the last picked is 1), drawn over the plan
 * without taking clicks.
 */
export const MapEditSelectedZones: React.FC<MapEditSelectedZonesProps> = (
  props
) => {
  const { selectedZones, zonesInfo, className } = props;
  const { mapInfo } = zonesInfo;

  // A zone drawn without a stroked circle, path or ellipse has no circle to
  // draw the spot on. Dropping those here keeps the numbering on what is drawn.
  const items = React.useMemo(() => {
    return selectedZones
      .map((zoneId) => zonesInfo.zones.find((zone) => zone.id === zoneId))
      .filter((zone) => !!zone?.circle);
  }, [selectedZones, zonesInfo.zones]);

  if (!mapInfo) {
    return null;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...mapInfo.attrs}
      className={cn("interactive-zone-svg pointer-events-none", className)}
    >
      {items.map((item, index) => {
        return (
          <InteractiveActiveSpot
            key={item!.id}
            zone={item!}
            title={String(items.length - index)}
            className={"map-edit-element-selected"}
          />
        );
      })}
    </svg>
  );
};
